// La descarga del XML entrega el documento AUTORIZADO por el SRI (<autorizacion> con
// el comprobante adentro). Si el backend ya no lo tiene ni el SRI lo devuelve (su WS
// responde por una ventana de tiempo), cae al comprobante firmado: se avisa para que
// nadie lo tome por el autorizado (H59).
export const SIGNED_XML_NOTICE = {
    severity: 'info',
    summary: 'XML firmado',
    detail: 'Se descargó el comprobante firmado: el SRI ya no devuelve el autorizado.',
    life: 8000,
};

export async function authorizedXmlNotice(blob) {
    if (!(blob instanceof Blob)) return null;
    try {
        const text = await blob.text();
        return text.indexOf('<autorizacion') !== -1 ? null : SIGNED_XML_NOTICE;
    } catch (e) {
        return null;
    }
}
